const history = {
  title: 'Mes projets',
  upgradeBtn: 'Mises à niveau',
  subTitle:
    "N'oubliez pas de télécharger votre fichier, il sera supprimé après 72 heures.",
  MAgo: 'il y a {{num}} minutes',
  HAgo: 'il y a {{num}} heures',
  DAgo: 'il y a {{num}} heures',
  justNow: "A l'instant",
  originalFile: 'Fichier original',
  selectAllBtn: 'Sélectionner tout',
  emptyTips: "Pas encore d'éléments, <1>allez à l'édition</1>",
  deleteTips: 'Êtes-vous sur de vouloir le supprimer ?',
};

export default history;
